module.exports = __webpack_public_path__ + "static/11Amplify-f60c0fe87121208b47f6c0a2582ee0f1.jpg";